import api from '@/api/api';
import { ApiVideoChat } from '.';
import getApiResponse from '@/api/apiResponse';

export interface IVideoLinkInfo {
  Inviter: string;
  RoomName: string;
  ExpireDate: string;
}

export interface IVerifyPasswordResult {
  ChatUrl: string;
  RefKey: string;
}

const VideoChatService = {
  getVideoChatUrl: async (id: string, userName: string) => {
    const params = { id, userName };
    console.log(params, 'getVideoChatUrl.params');
    const res = await api.get(ApiVideoChat.GET_VIDEO_CHAT_URL, { params });
    return getApiResponse<string>(res);
  },

  getGuestVideoChatUrl: async (id: string) => {
    const postData = { RefKey: id };
    console.log(postData, 'getGuestVideoChatUrl.postData');
    const res = await api.post(ApiVideoChat.GET_GUEST_VIDEO_CHAT_URL, postData);
    return getApiResponse<string>(res);
  },

  getLinkInfo: async (access: string) => {
    const params = { access };
    console.log(params, 'getLinkInfo.params');
    const res = await api.get(ApiVideoChat.GET_LINK_INFO, { params });
    return getApiResponse<IVideoLinkInfo>(res);
  },

  getLinkRoomUsers: async (access: string) => {
    const params = { access };
    console.log(params, 'getLinkRoomUsers.params');
    const res = await api.get(ApiVideoChat.GET_LINK_ROOM_USERS, { params });
    return getApiResponse<string[]>(res);
  },

  verifyLinkPassword: async (access: string, userName: string, password: string) => {
    const params = {};
    const postData = { AccessKey: access, UserName: userName, Password: password };
    console.log(params, 'verifyLinkPassword.params');
    const res = await api.post(ApiVideoChat.VERIFY_LINK_PASSWORD, postData, { params });
    return getApiResponse<IVerifyPasswordResult>(res);
  },
};

export default VideoChatService;
